<template>
    <div style="margin-top:20px;" class="top-line">
        <b-modal v-model="paymentTypeModel.show"
            size="sm"
            title="选择支付方式">
            <b-row align-v="center">
                <b-col lg="12">
                    <b-form-group>
                        <b-form-radio v-model="paymentTypeModel.selectedType"
                            name="paymentType"
                            value="fund">余额支付(余额:￥{{paymentTypeModel.memberFund}})</b-form-radio>
                        <!-- <b-form-radio v-model="paymentTypeModel.selectedType"
                            name="paymentType"
                            value="weixin">微信支付</b-form-radio>
                        <b-form-radio v-model="paymentTypeModel.selectedType"
                            name="paymentType"
                            value="alipay">支付宝支付</b-form-radio>
                        <b-form-radio v-model="paymentTypeModel.selectedType"
                            name="paymentType"
                            value="transfer">银行转账</b-form-radio> -->
                    </b-form-group>
                </b-col>
            </b-row>
            <template slot="modal-footer">
                <b-button size="sm"
                    variant="success"
                    @click="submitSalesPayment()">支付</b-button>
                <b-button size="sm"
                    variant="danger"
                    @click="paymentTypeModel.show = false">取消</b-button>
            </template>
        </b-modal>
        <b-modal id="payDeposteModel"
            v-model="payDeposteModel.show"
            title="会员付款">
            <b-row align-v="center">
                <b-col lg="12"
                    class="registerInfo">
                    <b-form>
                        <b-form-group label="绑定定单:"
                            label-cols-lg="3"
                            label-align-lg="right"
                            label-size="sm">
                            <b-form-input v-model="payDeposteModel.preSaleOrderRecordCode"
                                size="sm"
                                readonly></b-form-input>
                        </b-form-group>
                    </b-form>
                    <b-form>
                        <b-form-group label="总金额:"
                            label-cols-lg="3"
                            label-align-lg="right"
                            label-size="sm">
                            <b-form-input v-model="payDeposteModel.preSaleOrderRecordTotalOrderCost"
                                size="sm"
                                readonly></b-form-input>
                        </b-form-group>
                    </b-form>
                    <b-form>
                        <b-form-group label="最小定金支付额:"
                            label-cols-lg="3"
                            label-align-lg="right"
                            label-size="sm">
                            <b-form-input :value="payDeposteModel.preSaleOrderRecordDepositDue"
                                size="sm"
                                readonly></b-form-input>
                        </b-form-group>
                    </b-form>
                    <b-form>
                        <b-form-group label="已支付定金:"
                            label-cols-lg="3"
                            label-align-lg="right"
                            label-size="sm">
                            <b-form-input v-model="payDeposteModel.preSaleOrderRecordDepositPaymentSum"
                                size="sm"
                                readonly></b-form-input>
                        </b-form-group>
                    </b-form>
                    <b-form>
                        <b-form-group label="实际支付定金:"
                            label-cols-lg="3"
                            label-align-lg="right"
                            label-size="sm">
                            <b-form-input v-model="payDeposteModel.depositValue"
                                type="number"
                                size="sm"></b-form-input>
                        </b-form-group>
                    </b-form>
                </b-col>
            </b-row>

            <template slot="modal-footer">
                <b-button size="sm"
                    variant="success"
                    @click="submitBookingOrderDeposite()">
                    确认支付
                </b-button>
                <b-button size="sm"
                    variant="danger"
                    @click="payDeposteModel.show = false">
                    取消
                </b-button>
            </template>
        </b-modal>
        <div class="d-flex justify-content-between search-wrap">
            <div class="d-flex">
                <DatePicker type="daterange"
                    v-model="selectDates"
                    transfer
                    placement="bottom-end"
                    placeholder="选择下单时间"
                    style="width: 200px;"
                    @on-change="onDateChange" class="search-input"></DatePicker>
                <b-input-group style="width:220px;margin-left:10px;">
                    <b-form-input size="sm"
                        v-model="keyword"
                        placeholder="输入查询定单号" class="order-input"></b-form-input>
                    <b-input-group-append>
                        <b-button size="sm"
                            v-on:click="onSearch()" class="order-button">查询</b-button>
                    </b-input-group-append>
                </b-input-group>
                <b-button size="sm"
                    variant="success"
                    style="margin-left:10px"
                    @click="onExport()" class="order-button">
                    导出
                </b-button>
            </div>

            <b-form-radio-group v-model="salesOrder.orderType"
                @change="onSalesOrderTypeChange()" class="radio-wrap">
                <b-form-radio value="全部">全部</b-form-radio>
                <b-form-radio value="未支付">未支付</b-form-radio>
                <b-form-radio value="已支付">已支付</b-form-radio>
                <b-form-radio value="预发货">预发货</b-form-radio>
                <b-form-radio value="未发货">未发货</b-form-radio>
                <b-form-radio value="已发货">已发货</b-form-radio>
                <b-form-radio value="已成交">已成交</b-form-radio>
            </b-form-radio-group>
        </div>

        <!-- <b-form-group style="float:right;"> -->

        <!-- </b-form-group> -->
        <div class="dataTable">
            <b-table id="sales-cart-table"
                :fields="salesOrder.fields"
                :items="salesOrder.items"
                small
                bordered
                hover
                show-empty
                empty-text="没有找到匹配的记录"
                :busy="salesOrder.isTableBusy"
                caption-top>
                <template slot="table-caption">
                    <!-- <span>苗定单列表</span> -->
                </template>
                <div slot="table-busy"
                    class="text-center text-info my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>加载中...</strong>
                </div>
                <template v-slot:cell(salesOrderAction)="row">
                    <b-link v-if="row.item.shoppingType === '现售'"
                        :to="{path: '/member/order-detail', query: { curSaleOrderRecordUuid: row.item.recordUuid }}"
                        target="_blank">查看</b-link>
                    <b-link v-if="row.item.shoppingType === '预售'"
                        :to="{path: '/member/booking-order-detail', query: { preSaleOrderRecordUuid: row.item.recordUuid }}"
                        target="_blank">查看</b-link>
                    /
                    <!-- <b-link :href="api.fileServer + row.item.orderContract"
                        target="_blank">合同</b-link>
                    / -->
                    <b-link href="#"
                        v-on:click="onSginContract(row)">{{row.item.orderContractSign == 1 ? '下载' : '签署'}}</b-link>
                    <span v-if="row.item.recordPaidStatus === '未支付' && row.item.recordOrderStatus !== '撤单'">
                        /
                        <a href="#"
                            v-on:click="onCloseOrder(row)">关闭</a> /
                        <a href="#"
                            v-on:click="onPayOrder(row)">{{row.item.shoppingType === '现售' ? '付款':'付定金'}}</a>
                    </span>
                </template>
                <template v-slot:cell(recordCreateAt)="row">
                    <span>{{formatDateTimeString(row.item.recordCreateAt)}}</span>
                </template>
                <template v-slot:cell(recordPayExpires)="row">
                    <span>{{formatDateTimeString(row.item.recordPayExpires)}}</span>
                </template>
            </b-table>
        </div>
		
        <b-pagination v-model="salesOrder.feSearch.limit.conditions.pageStart"
            style="margin-top:20px;"
            :total-rows="salesOrder.feSearch.limit.conditions.total"
            :per-page="salesOrder.feSearch.limit.conditions.pageLength"
            align="center"
            size="sm"
            first-text="首页"
            prev-text="上一页"
            next-text="下一页"
            last-text="尾页"
            @change="onSalesOrderChange"></b-pagination>
        <PayModal ref="payModal" />
		
		
		
    </div>
</template>

<script>
import api from "@/api/api";
import { formatDateTimeString, numberToFixed } from "@/libs/utils";
import search from "@/libs/search";
import "@/style/global.css";
import PayModal from '../member/pay';
export default {
    name: "OrderList",
    components: { PayModal },
    data() {
        return {
            api,
            keyword: '',
            selectDates: [],
            salesOrder: {
                fields: [
                    { key: "recordCode", label: "定单编号", excel: true },
                    { key: "seedFarmCode", label: "苗场编号", excel: true },
                    { key: "shoppingType", label: "类型", excel: true },
                    { key: "customerName", label: "下单客人", excel: true },
                    { key: "recordTotalPieces", label: "总件数", excel: true },
                    { key: "recordTotalDeliveryFee", label: "总运费", excel: true },
                    { key: "recordTotalProductCost", label: "总货款", excel: true },
                    { key: "recordTotalOrderCost", label: "总金额", excel: true },
                    { key: "recordDepositPaymentSum", label: "已付定金", excel: true },
                    { key: "recordOrderStatus", label: "定单状态", excel: true },
                    { key: "recordPaidStatus", label: "支付状态", excel: true },
                    { key: "mainRecordStationShipStatus", label: "配送状态", excel: true },
                    { key: "recordCreateAt", label: "定单时间", excel: true },
                    { key: "recordPayExpires", label: "最晚付款时间", excel: true },
                    { key: "salesOrderAction", label: "操作" }
                ],
                items: [],
                isTableBusy: false,
                feSearch: search.getSearchParams(),
                orderType: '全部'
            },
            paymentTypeModel: {
                show: false,
                curSaleOrderRecordUuid: "",
                depositValue: 0,
                selectedType: "fund",
                memberFund: 0
            },
            payDeposteModel: {
                show: false,
                preSaleOrderRecordUuid: '',
                preSaleOrderRecordCode: '',
                preSaleOrderRecordTotalOrderCost: '',
                preSaleOrderRecordDepositDue: '',
                preSaleOrderRecordDepositPaymentSum: '',
                depositValue: ''
            }
        };
    },
    mounted() {
        if (!this.checkMemberLogin()) {
            this.$router.push({
                name: 'MemberLogin'
            });
            return;
        };
        this.salesOrder.feSearch.filters.enable = true;
        this.getCombineOrderList();
        this.getMemberBalance();
    },
    methods: {
        formatDateTimeString,
        numberToFixed,
        getMemberBalance() {
            api.webGetMemberUserDetail({
                userUuid: this.getLoginCookieUuid()
            }).then(res => {
                if (res.code === 0) {
                    this.paymentTypeModel.memberFund = res.data.memberFund;
                }
            });
        },
        onDateChange(e) {
            this.selectDates = e;
            let field = "recordCreateAt";
            search.globalRemoveFilterConditionKey(this.salesOrder.feSearch, field);
            this.salesOrder.feSearch.filters.conditions.push({
                name: field,
                type: 'datebetween',
                value: JSON.stringify(e)
            });
            search.globalResetSearch(this.salesOrder.feSearch);
            this.getCombineOrderList();
        },
        onSearch() {
            let field = "recordCode";
            search.globalRemoveFilterConditionKey(this.salesOrder.feSearch, field);
            search.globalResetSearch(this.salesOrder.feSearch);
            if (this.keyword) {
                this.salesOrder.feSearch.filters.conditions.push({
                    name: field,
                    type: 'like',
                    value: this.keyword
                });
            }
            this.getCombineOrderList();
        },
        onExport() {
            const searchCondition = search.deepClone(this.salesOrder.feSearch);
            searchCondition.limit.enable = false;
            searchCondition.excelExport.enable = true;
            searchCondition.excelExport.columns = this.salesOrder.fields
                .filter(col => col.excel)
                .map(col => {
                    return {
                        key: col.key,
                        title: col.label
                    };
                });

            this.salesOrder.isTableBusy = true;
            api.webGetOrderList(searchCondition).then(res => {
                this.salesOrder.isTableBusy = false;
                if (res.code === 0) {
                    let url = api.fileServer + res.data.exportFileName;
                    this.$downLoadFile(url);
                }
            });
        },
        getCombineOrderList() {
            this.salesOrder.isTableBusy = true;
            api.webGetOrderList(this.salesOrder.feSearch).then(res => {
                if (res.code === 0) {
                    this.salesOrder.isTableBusy = false;
                    this.salesOrder.items = res.data.records;
                    this.salesOrder.items.forEach(e => {
                        e.recordTotalOrderCost = this.numberToFixed(e.recordTotalDeliveryFee + e.recordTotalProductCost, 4);
                    });
                    search.globalSetFilterRecordCount(
                        this.salesOrder.feSearch,
                        res.data.filterRecordCount
                    );
                }
            });
        },
        onSalesOrderTypeChange() {
            this.$nextTick(function () {
                search.globalRemoveFilterConditionKey(this.salesOrder.feSearch, 'recordPaidStatus');
                search.globalRemoveFilterConditionKey(this.salesOrder.feSearch, 'recordOrderStatus');
                search.globalRemoveFilterConditionKey(this.salesOrder.feSearch, 'recordShipStatus');
                this.salesOrder.feSearch.showPreDelivery = 0;
                if (this.salesOrder.orderType === '未支付') {
                    this.salesOrder.feSearch.filters.conditions.push({
                        name: 'recordPaidStatus',
                        type: 'eq',
                        value: this.salesOrder.orderType
                    });
                }
                else if (this.salesOrder.orderType === '已支付') {
                    this.salesOrder.feSearch.filters.conditions.push({
                        name: 'recordPaidStatus',
                        type: 'in',
                        value: JSON.stringify(['定金已支付', '全额支付'])
                    });
                }
                else if (this.salesOrder.orderType === '预发货') {
                    this.salesOrder.feSearch.showPreDelivery = 1;
                }
                else if (this.salesOrder.orderType === '未发货' || this.salesOrder.orderType === '已发货') {
                    this.salesOrder.feSearch.filters.conditions.push({
                        name: 'recordShipStatus',
                        type: 'eq',
                        value: this.salesOrder.orderType
                    });
                }
                else if (this.salesOrder.orderType === '已成交') {
                    this.salesOrder.feSearch.filters.conditions.push({
                        name: 'recordOrderStatus',
                        type: 'eq',
                        value: this.salesOrder.orderType
                    });
                }
                this.getCombineOrderList();
            });
        },
        onSalesOrderChange(pageNum) {
            search.globalPageOnChange(this.salesOrder.feSearch, pageNum);
            this.getCombineOrderList();
        },
        onSginContract(row) {
            this.salesOrder.isTableBusy = true;
            api.AutoSignContract({
                shoppingType: row.item.shoppingType,
                orderUuid: row.item.recordUuid
            }).then(res => {
                this.salesOrder.isTableBusy = false;
                if (res.code === 0) {
                    window.open(res.data.signResult, "_blank");
                    // this.getCombineOrderList();
                }
            });
        },
        onCloseOrder(row) {
            this.$bvModal
                .msgBoxConfirm("是否确认关闭该定单？", {
                    size: "sm",
                    buttonSize: "sm",
                    okVariant: "danger",
                    okTitle: "是",
                    cancelTitle: "否"
                })
                .then(value => {
                    if (value) {
                        if (row.item.shoppingType === '现售') {
                            this.salesOrder.isTableBusy = true;
                            api.webCurrentSaleCloseOrder({
                                curSaleOrderRecordUuid: row.item.recordUuid
                            }).then(res => {
                                this.salesOrder.isTableBusy = false;
                                if (res.code === 0) {
                                    this.getCombineOrderList();
                                }
                            });
                        }
                        else if (row.item.shoppingType === '预售') {
                            this.salesOrder.isTableBusy = true;
                            api.webPreSaleCloseOrder({
                                preSaleOrderRecordUuid: row.item.recordUuid
                            }).then(res => {
                                this.salesOrder.isTableBusy = false;
                                if (res.code === 0) {
                                    this.getCombineOrderList();
                                }
                            });
                        }
                        else {

                        }

                    }
                });
        },
        onPayOrder(row) {
            this.$bvModal
                .msgBoxConfirm("是否确认支付该定单？", {
                    size: "sm",
                    buttonSize: "sm",
                    okVariant: "danger",
                    okTitle: "是",
                    cancelTitle: "否"
                })
                .then(value => {
                    if (value) {
                        if (row.item.shoppingType === '现售') {
                            this.paymentTypeModel.curSaleOrderRecordUuid = row.item.recordUuid;
                            this.paymentTypeModel.depositValue = row.item.recordTotalOrderCost;
                            this.paymentTypeModel.show = true;
                        }
                        else if (row.item.shoppingType === '预售') {
                            this.payDeposteModel.preSaleOrderRecordUuid = row.item.recordUuid;
                            this.payDeposteModel.preSaleOrderRecordCode = row.item.recordCode;
                            this.payDeposteModel.preSaleOrderRecordTotalOrderCost = row.item.recordTotalOrderCost;
                            this.payDeposteModel.preSaleOrderRecordDepositDue = row.item.recordDepositDue;
                            this.payDeposteModel.preSaleOrderRecordDepositPaymentSum = row.item.recordDepositPaymentSum;
                            this.payDeposteModel.depositValue = row.item.recordDepositDue;
                            // this.payDeposteModel.depositValue = 100;
                            this.payDeposteModel.show = true;
                        }
                        else {

                        }

                    }
                });
        },
        submitBookingOrderDeposite() {
            if (this.paymentTypeModel.depositValue < this.paymentTypeModel.preSaleOrderRecordDepositDue) {
                this.$bvModal.msgBoxOk("实际定金支付额需大于最小定金支付额", {
                    title: "提示",
                    buttonSize: "sm"
                });
                return;
            }
            api.webPreSaleDepositPayWithFund(this.payDeposteModel).then(res => {
                if (res.code === 0) {
                    this.payDeposteModel.show = false;
                    this.getCombineOrderList();
                }
                else {
                    if (res.message === '余额不足') {
                        this.$refs.payModal.showModal();
                    }
                    // console.log(res);
                }
            });
        },
        submitSalesPayment() {
            if (this.paymentTypeModel.selectedType === "fund") {
                api.webCurrentSalePayWithFund(this.paymentTypeModel).then(res => {
                    if (res.code === 0) {
                        this.paymentTypeModel.show = false;
                        this.getCombineOrderList();
                    }
                    else {
                        if (res.message === '余额不足') {
                            this.$refs.payModal.showModal();
                        }
                        // console.log(res);
                    }
                });
            }
            else {
                this.$bvModal.msgBoxOk("暂不支持该支付方式", {
                    title: "提示",
                    buttonSize: "sm"
                });
            }
        }
    }
};
</script>

<style>
	/* .top-line{border-top:1px solid #dbdbdb;} */
	.search-wrap{margin-top:30px;}
	
	/* 选择下单日期 */
	.search-input .ivu-input{height:32px;line-height:32px;width:200px;padding: 0px 7px;color:#333;}
	.search-input .ivu-input-prefix i, .ivu-input-suffix i {font-size: 22px;line-height: 32px; color: #808695;}
	
	
	.order-input{height:32px;line-height:32px;width:220px;padding: 0px 7px;color:#333;}
	.order-button{height:32px;line-height:32px;width:50px;padding:0px;}
	
	.custom-control-input:checked~.custom-control-label::before{color: #fff !important;
    border-color: #28a745 !important;
    background-color: #28a745 !important;}
	.custom-checkbox .custom-control-input:checked~.custom-control-label::after{background-color:#01B252 !important;}
	/* 表格 */
	.dataTable{margin-top:20px;}
	.dataTable th{background-color:#efefef;height:32px;line-height:32px;}
	
	.table thead th{vertical-align: bottom; border-bottom: 2px solid #dbdbdb;}

	.table-bordered td, .table-bordered th {border: 1px solid #dbdbdb;}
	.table-sm td, .table-sm th{padding:10px 5px;}
	 /* 表格操作 */
	.table-sm td a{color:#00B151;}
	/* 页码 */
	.page-link{color:#757575 !important;}
	.page-link:hover{color: #00b151 !important;}
	.page-item.active .page-link{color:#fff !important;background-color: #28a745 !important;border-color: #28a745 !important;}
	.pagination-sm .page-link{
		padding: 5px 12px !important;
		margin-top: 40px;
		}	
	.page-link:focus{box-shadow: none !important;}		
	
	

	.radio-wrap .custom-control-label{padding-top:0px;}
</style>



// WEBPACK FOOTER //
// src/view/member/order-list.vue